// Proje katılımcı (müşteri) şemaları — Müşteri Katılımcı Rolü (Task 5).
// plan: docs/superpowers/plans/2026-07-23-musteri-katilimci-rolu.md
// Servis katmanı (project-participants.ts, Task 4) bu şemalarla birebir uyumlu
// dönüş şekilleri üretir — request body'ler + response DTO'ları.

import { z } from "zod";
import { PARTICIPANT_STATUSES } from "../constants/index.js";

export const participantStatusEnum = z.enum(PARTICIPANT_STATUSES);

// POST /projects/:id/participants — davet
export const InviteParticipantRequestSchema = z.object({
  email: z.string().email(),
  fullName: z.string().min(1).max(200),
});
export type InviteParticipantRequest = z.infer<typeof InviteParticipantRequestSchema>;

export const InviteParticipantResponseSchema = z.object({
  participantId: z.string().uuid(),
  userCreated: z.boolean(),
  mailSent: z.boolean(),
});
export type InviteParticipantResponse = z.infer<typeof InviteParticipantResponseSchema>;

// GET /projects/:id/participants — liste
export const ProjectParticipantSchema = z.object({
  id: z.string().uuid(),
  userId: z.string().uuid(),
  email: z.string().email(),
  fullName: z.string(),
  status: participantStatusEnum,
  invitedBy: z.string().uuid().nullable(),
  submittedAt: z.string().datetime().nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
export type ProjectParticipant = z.infer<typeof ProjectParticipantSchema>;

export const ParticipantListResponseSchema = z.object({
  participants: z.array(ProjectParticipantSchema),
});
export type ParticipantListResponse = z.infer<typeof ParticipantListResponseSchema>;

// PATCH /projects/:id/participants/:pid — danışman: yeniden aç / iptal
export const SetParticipantStatusRequestSchema = z.object({
  status: z.enum(["active", "revoked"]),
});
export type SetParticipantStatusRequest = z.infer<typeof SetParticipantStatusRequestSchema>;

// POST /projects/:id/participants/:pid/resend
export const ResendInviteResponseSchema = z.object({
  mailSent: z.boolean(),
});
export type ResendInviteResponse = z.infer<typeof ResendInviteResponseSchema>;
